module.exports = __webpack_public_path__ + "img/play_button.1ed43bf9.png";